<div class="disclosures">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#disclosure-doc'"></app-title-page>
            </div>
            <!-- documents -->
            <div class="col-md-12 documents" id="disclosure-doc">
                <div class="lane-top">
                    <div class="row mt-5">
                        <!-- Supporting Professionals & Insitituions -->
                        <div class="col-md-12">
                            <!-- <h5>Supporting Professionals & Insitituions</h5> -->
                            <h3 class="f-subtit">{{ dataSection[0]?.title }}</h3>
                            <div class="mt-3" *ngIf="dataSection[0]?.card.length != 0">
                                <div class="col-xl-10 col-md-11 mx-auto">
                                    <div class="supporting">
                                        <div class="row">
                                            <div class="col-md-6 py-3 px-md-3 px-0" *ngFor="let address of dataSection[0]?.card">
                                                <div class="border-type-1 address no-list p-3"  [innerHTML]="address.description"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Anggaran Dasar -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit mb-3">{{ dataSection[1]?.title }}</h3>
                            <ng-container *ngFor="let data of dataAnggaranDasar">
                                <div class="desc text-justify" [innerHTML]="data?.description"></div>
                                <div class="row my-5">
                                    <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-9 mx-auto">
                                        <a href="{{apiAsset}}/{{data?.filename}}" 
                                            target="_blank" 
                                            class="btn red-btn-icon w-100">
                                            {{ isLang?.download }} {{ data?.title }}
                                            <img src="../../../../assets/images/icon/dwnload-icon.svg" alt="">
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <!-- Prospectus -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit mb-3">{{ dataSection[2]?.title }}</h3>
                            <ng-container *ngFor="let data of dataProspectus">
                                <div class="desc text-justify" [innerHTML]="data?.description"></div>
                                <div class="row my-5">
                                    <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-9 mx-auto">
                                        <a href="{{apiAsset}}/{{data?.filename}}" 
                                            target="_blank" 
                                            class="btn red-btn-icon w-100">
                                            {{ isLang?.download }} {{ data?.title }}
                                            <img src="../../../../assets/images/icon/dwnload-icon.svg" alt="">
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <!-- Announcement -->
                        <div class="col-md-12">
                            <h3 class="f-subtit mb-3">{{ dataSection[3]?.title }}</h3>
                            <div class="desc text-justify" [innerHTML]="dataSection[3]?.content"></div>
                            <div class="statements mt-4" *ngIf="yearAnnoun">
                                <div class="row">
                                    <div class="col-lg-3 col-md-4 col-sm-7 col-10 mx-md-0 mx-auto">
                                        <h5 class="tit-f18b text-md-left text-center">{{ isLang?.selectYears }}</h5>
                                        <div class="select-ver2 mt-3">
                                            <ng-select2 [(ngModel)]="yearAnnoun"
                                                        [data]="dataYearAnnoun" 
                                                        (valueChanged)="valueChangedAnnoun($event)"
                                                        [placeholder]="isLang?.selectYears">
                                            </ng-select2>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-4" *ngIf="dataPerAnnoun">
                                    <app-widget-pdf [isActive]="isActivePdf" [dataWidgetPdf]="dataPerAnnoun"></app-widget-pdf>
                                </div>
                            </div>
                        </div>
                        <!-- Bonds -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit mb-3">{{ dataSection[4]?.title }}</h3>
                            <div class="desc text-justify" [innerHTML]="dataSection[4]?.content"></div>
                            <p class="mb-4">{{ isLang?.pleaseClick }} {{ dataBond?.title }}:</p>
                            <div class="row">
                                <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-9 mx-auto">
                                    <a href="{{apiAsset}}/{{dataBond?.filename}}" 
                                        class="btn red-btn-icon w-100"
                                        target="_blank">
                                        {{ isLang?.download }} {{ dataBond?.title }}
                                        <img src="../../../../assets/images/icon/dwnload-icon.svg" alt="">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>
